import { DEBUG, PATH } from '../constants';


const base = PATH;
const debug = DEBUG;

export async function getAllQuestions() {
  try {
    const response = await fetch(base + 'questions-inde');
    return await response.json();
  } catch (error) {
    if (debug) console.error('Erreur getAllQuestions', error);
    throw error;
  }
}
  
export async function getAllQuestionsByGame(g) {
  try {
    const response = await fetch(base + 'questions-inde/g/' + g);
    return await response.json();
  } catch (error) {
    if (debug) console.error('Erreur getAllQuestionsByGame', error);
    throw error;
  }
}

export async function getAbortedQuestions(progressionId) {
  try {
    const response = await fetch(base + 'questions-inde/aborted/' + progressionId);
    return await response.json();
  } catch (error) {
    if (debug) console.error('Erreur getAllQuestionsByGame', error);
    throw error;
  }
}
    
export async function createQuestion(gameId, libelle, type) {
  try {
    const authToken = localStorage.getItem("authToken");

    // Création de l'objet FormData pour envoyer des fichiers
    const formData = new FormData();
    formData.append('libelle', libelle);
    formData.append('id_game', gameId);
    formData.append('type', type);

    const response = await fetch(base + 'questions-inde/insert', {
      method: 'POST',
      credentials: "include",
      headers: { 'Authorization': `Bearer ${authToken}` },
      body: formData
    });
    return await response.json();
  } catch (error) {
    if (debug) console.error('Erreur createQuestion', error);
    throw error;
  }
}

export async function updateQuestion(id, libelle, type, helperText, helperImage = null, deleteImgHelper = false) {
  try {
    const authToken = localStorage.getItem("authToken");

    const formData = new FormData();
    formData.append('id', id);
    formData.append('libelle', libelle);
    formData.append('type', type);
    formData.append('delete_img_helper', deleteImgHelper);

    // Indices (texte et image peuvent coexister maintenant)
    if (helperText) {
      formData.append('helper', helperText);
    }
    
    if (helperImage instanceof File) {
      formData.append('img_helper', helperImage);
    }

    const response = await fetch(base + 'questions-inde/update', {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Authorization': `Bearer ${authToken}`,
      },
      body: formData,
    });

    return await response.json();
  } catch (error) {
    if (debug) console.error('Erreur updateQuestion', error);
    throw error;
  }
}

export async function updateQuestionImage(id, image = null, deleteImage = false) {
  try {
    const authToken = localStorage.getItem("authToken");

    const formData = new FormData();
    formData.append('id', id);
    formData.append('delete_img', deleteImage);
    
    if (image instanceof File) {
      formData.append('img', image);
    }

    const response = await fetch(base + 'questions-inde/update-img', {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Authorization': `Bearer ${authToken}`,
      },
      body: formData,
    });

    return await response.json();
  } catch (error) {
    if (debug) console.error('Erreur updateQuestion', error);
    throw error;
  }
}

export async function updateQuestionOptions(id, hintKey, message, hintImage = null, deleteImgKey = false) {
  try {
    const authToken = localStorage.getItem("authToken");

    const formData = new FormData();
    formData.append('id', id);
    formData.append('cle_indice', hintKey);
    formData.append('message', message);
    formData.append('delete_img_indice', deleteImgKey);

    // Indices (texte et image peuvent coexister maintenant)
    
    if (hintImage instanceof File) {
      formData.append('img_indice', hintImage);
    }

    const response = await fetch(base + 'questions-inde/update-options', {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Authorization': `Bearer ${authToken}`,
      },
      body: formData,
    });

    return await response.json();
  } catch (error) {
    if (debug) console.error('Erreur updateQuestionOptions', error);
    throw error;
  }
}

export async function deleteQuestion(questionId) { 
    try {
        const authToken = localStorage.getItem("authToken"); 
        const response = await fetch(base + 'questions-inde/delete', {
        method: 'POST',
        credentials: "include", 
        headers: { 
            'Content-Type': 'application/x-www-form-urlencoded',
            'Authorization': `Bearer ${authToken}` 
        },
        body: new URLSearchParams({id: questionId }),
        });
        return await response.json();
    } catch (error) {
        console.error('Erreur deleteQuestion', error);
        throw error;
    }
}


    